import { APIResponse } from '../models/api-response.model';
import { APIServiceService } from './apiservice.service';
import { User } from '../models/user.model';
import { Observable, observable } from 'rxjs';

export class UtilityEndpoint {

  constructor(private apiService: APIServiceService) {}



  async sendSMS(smsNumber: string, smsMessage: string): Promise<APIResponse> {
    try {
      const token = await this.apiService.getCurrentUserToken();
      if (!token) {
        throw new Error('no_auth_token');
      }
      const response = await this.apiService.doPOST('utility/sms', token, { smsNumber, smsMessage }).toPromise();
      return response;
    } catch (error) {
      throw error;
    }
  }

}
